import { render } from "./PositionsTableHtml.vue?vue&type=template&id=9cec80c2&scoped=true&ts=true"
import script from "./PositionsTableHtml.vue?vue&type=script&lang=ts"
export * from "./PositionsTableHtml.vue?vue&type=script&lang=ts"

import "./PositionsTableHtml.vue?vue&type=style&index=0&id=9cec80c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cec80c2"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QIcon,QSelect,QMenu,QCard,QCardSection,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
